<template>
	<div>
			<TopAppBar
				:leftBtnMode="leftBtnMode"
				:rightBtnMode="rightBtnMode"
				:title="titleBrand"
				:leftBtnMethod="leftBtnMethod"
				:rightBtnMethod="rightBtnMethod"
        :hideCategory="false"
				staticMode="true"
			></TopAppBar>
		<div class="d-flex h-full flex-column">
			<TopAppBarDrawer></TopAppBarDrawer>
			<main class="main-wrapper flex-grow-1" >
				<div class="d-flex align-items-center ">
						<div class="t-headline13 t-color-headlineBlack pda-14 font-m flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center">
							{{this.$t("1720")}}
						</div>
				</div>
				<div class="divider"></div>
				<!-- subtabs -->

			<div class="scroll-x"  v-if="certificateData && certificateData.printType && certificateData.printType.value=='HEIGHT'">
				<div class="container--certificate-portrait mgt-50">
					<div class="container--certificate-wrapper">
					<div class="certificate_background"><img :src="certificateData.image" alt=""></div>
					<div class="container--certificate-portrait-inner">
							<div class="t-center t-subtitle3 font-m l-spacing48 t-line-h-20">
											<!-- 비즈니스 커뮤니케이션 전문가<br>
											달성 기념 수료증 -->
											{{certificateData?certificateData.name:''}}
							</div>
							<div class="mgt-16 t-center t-subtitle4 font-m l-spacing54 t-line-h-22"  v-if="certificateData && certificateData.params && certificateData.params.MEMBER_NAME">{{certificateData.params.MEMBER_NAME}} </div>
							<div class="divider mgt-16 mgb-16 certificate-portrait"></div>
							<div class="d-flex justify-content-around flex-column">
											<div class="t-body3 t-line-h-22 t-color-bodyGrayA l-spacing42 t-center mgb-16" v-if="certificateData && certificateData.params && certificateData.params.BELONG">{{certificateData.params.BELONG}}
											</div>
											<div class="t-body3 t-line-h-22 t-color-bodyGrayA l-spacing42 t-center pdr-9" v-if="certificateData && certificateData.params && certificateData.params.DEGREE_NAME">{{certificateData.params.DEGREE_NAME}}
											</div>
							</div>
							<div class="mgt-32 t-center t-body3 l-spacing42 t-line-h-20 font-r h-60" v-if="certificateData && certificateData.params && certificateData.params.CONTENTS" v-html="certificateData.params.CONTENTS">
							{{certificateData.params.CONTENTS}} <br>
							</div>
					</div>
							<div class="mgt-5 pdt-50 pdr-36 pdl-36 pdb-50 d-flex justify-content-between flex-column">
								<div class="t-helper t-color-bodyGrayA l-spacing36 t-line-h-22 font-r min-w-100 t-center mgb-8" v-if="certificateData && certificateData.params && certificateData.params.ISSUE_DATE">{{$moment.unix(certificateData.params.ISSUE_DATE/1000).format("L")}}</div>
								<div class="t-helper t-color-bodyGrayA l-spacing36 t-line-h-22 font-r min-w-100 t-center pdb-13" v-if="certificateData && certificateData.params && certificateData.params.ISSUE_ORGANIZATION_NAME">{{certificateData.params.ISSUE_ORGANIZATION_NAME}}	</div>
							</div>
							<div class="card_bg"><img :src="certificateData.image" alt=""></div>
					</div>
					</div>
			</div>

			<div class="scroll-x"  v-if="certificateData && certificateData.printType && certificateData.printType.value=='WIDTH'">
				<div class="container--certificate-landscape mgt-50">
				<div class="container--certificate-wrapper">
						<div class="container--certificate-landscape-inner">
									<div class="t-center t-subtitle3 font-m l-spacing48 t-line-h-20">
													{{certificateData?certificateData.name:''}}
									</div>
									<div class="mgt-16 t-center t-subtitle4 font-m l-spacing54 t-line-h-22" v-if="certificateData && certificateData.params && certificateData.params.MEMBER_NAME">{{certificateData.params.MEMBER_NAME}}	</div>
									<div class="divider mgt-16 mgb-16 certificate-landscape"></div>
									<div class="d-flex justify-content-around">
											<div class="t-body3 t-line-h-22 t-color-bodyGrayA l-spacing42 t-center" v-if="certificateData && certificateData.params && certificateData.params.BELONG">{{certificateData.params.BELONG}}</div>
											<div class="t-body3 t-line-h-22 t-color-bodyGrayA l-spacing42 t-center pdr-9" v-if="certificateData && certificateData.params && certificateData.params.DEGREE_NAME">{{certificateData.params.DEGREE_NAME}}</div>
									</div>
									<div class="mgt-32 t-center t-body3 l-spacing42 t-line-h-20 font-r h-42" v-if="certificateData && certificateData.params && certificateData.params.CONTENTS" v-html="certificateData.params.CONTENTS">
								{{certificateData.params.CONTENTS}} <br></div>

								
					</div>
					<div class="pdt-34 pdr-36 pdl-36 pdb-36 d-flex justify-content-between">
									<div class="t-helper t-color-bodyGrayA l-spacing36 t-line-h-22 font-r min-w-100 t-center" v-if="certificateData && certificateData.params && certificateData.params.ISSUE_DATE">{{$moment.unix(certificateData.params.ISSUE_DATE/1000).format("L")}}</div>
									<div class="t-helper t-color-bodyGrayA l-spacing36 t-line-h-22 font-r min-w-100 t-center" v-if="certificateData && certificateData.params && certificateData.params.ISSUE_ORGANIZATION_NAME">{{certificateData.params.ISSUE_ORGANIZATION_NAME}} </div>
					</div>
					<div class="certificate_background"><img :src="certificateData.image" alt=""></div>
					</div>
					</div>
			</div>
		<div class="mgt-50"></div>
	</main>
	</div>
	</div>
</template>
<script>
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import rewardApi from "@/api/rewardApi.js";

export default {
	name: "CertificateDetail",
	data() {
		return {
			title: "",
			titleBrand:null,
			leftBtnMethod: () => {
				this.$router.go(-1);
			},
			certificateData: null,
			certificate: null
		};
	},
	filters: {
		charLength(value) {
			if (value.length > 30) {
				return value.substring(0, 30) + "..";
			} else {
				return value;
			}
		},
	},
	components: {
		TopAppBar,
		TopAppBarDrawer
	},

	mixins: [topAppBarMixin],

	watch: {
		$route(to, from) {},
	},

	mounted() {
		let id = this.$router.currentRoute.params.id;
		this.titleBrand = localStorage.getItem('brandName');
		this.setTopAppBarBackReward();
		this.fetchData(id);
	},

	methods: {
		fetchData(id) {
			let parmas = { id:id };
			rewardApi
				.certificateDetail(id)
				.then((response) => {
					this.certificateData = response.data.data;
				})
				.catch((err) => {});
		}
	},
};
</script>

<style scoped>
.certificate_background {
	position: absolute;
	top: 0;
	left: 0;
	z-index: -1;
}
</style>
